import { productsService } from 'domains/products/products.service';
import type { GetServerSidePropsContext } from 'next';

import type { AppStore } from 'redux-store';

import { BaseServerAbstract } from './base.server.abstract';

export class PaymentsPageServerAbstract extends BaseServerAbstract {
  protected screen = '';

  async loadProducts({
    context,
    store,
    coupon,
    screen = this.screen,
  }: {
    context: GetServerSidePropsContext;
    store: AppStore;
    screen?: string;
    coupon?: string;
  }): Promise<void> {
    await productsService.getProductsV3(
      { store, screen: screen, coupon },
      context,
    );
  }
  
  async server({
    context,
    store,
  }: {
    context: GetServerSidePropsContext;
    store: AppStore;
  }): Promise<void> {
    const coupon = context.query.coupon as string | undefined;
    await this.checkToken({ context, store });

    await Promise.allSettled([
      super.server({
        context,
        store,
      }),
      this.loadProducts({ context, store, coupon }),
      this.isAuthenticated({ context })
        ? productsService.getPaymentMethods({ store }, context)
        : null,
    ]);
  }
}
